let swipers = {
    advantages: globalSwipers.advantages
};

$(function() {
    checkSliders(swipers);

    $(window).on('resize', function () {
        checkSliders(swipers);
    });

    $('.contact-streetview .c-link').on('click', function(event) {
        const $this = $(this);

        event.preventDefault();

        $('.contact-streetview iframe').attr('src', 'https://www.google.com/maps/embed?pb=!1m0!3m2!1sen!2sus!4v1476335141209!6m8!1m7!1sAWSwz4XC8hAAAAQ1tz5mVQ!2m2!1d48.12291635403875!2d17.10203031027299!3f310.6822273646001!4f-14.969027535036062!5f0.5970117501821992&amp;output=embed');

        $this.parent().addClass('loading');

        setTimeout(function () {
            $this.parent().addClass('is-active');

            setTimeout(function () {
                $this.hide();
            }, 500);
        }, 2500);
    });
});
